module.exports = __webpack_public_path__ + "static/media/standart.8cd1ce69.jpg";